import { FC, SVGProps } from 'react';

interface SlackLogoProps extends SVGProps<SVGSVGElement> {
	// Render the mark in a single `currentColor` fill instead of the full-color
	// brand mark, so it themes with its context (like GitHub/Linear/Granola).
	// Use where the logo reflects state rather than identity — e.g. the
	// accent/lock treatment on locked connector previews.
	mono?: boolean;
}

// Slack brand mark. Defaults to the full-color mark; pass `mono` to render it in
// a single `currentColor` fill so consumers can theme it.
export const SlackLogo: FC<SlackLogoProps> = ({ mono = false, ...props }) => (
	<svg viewBox="0 0 2447.6 2452.5" xmlns="http://www.w3.org/2000/svg" fill="currentColor" aria-hidden="true" focusable="false" {...props}>
		<g clipRule="evenodd" fillRule="evenodd">
			<path
				d="m897.4 0c-135.3.1-244.8 109.9-244.7 245.2-.1 135.3 109.5 245.1 244.8 245.2h244.8v-245.1c.1-135.3-109.5-245.1-244.9-245.3.1 0 .1 0 0 0m0 654h-652.6c-135.3.1-244.9 109.9-244.8 245.2-.2 135.3 109.4 245.1 244.7 245.3h652.7c135.3-.1 244.9-109.9 244.8-245.2.1-135.4-109.5-245.2-244.8-245.3z"
				fill={mono ? undefined : '#36c5f0'}
			/>
			<path
				d="m2447.6 899.2c.1-135.3-109.5-245.1-244.8-245.2-135.3.1-244.9 109.9-244.8 245.2v245.3h244.8c135.3-.1 244.9-109.9 244.8-245.3zm-652.7 0v-654c.1-135.2-109.4-245-244.7-245.2-135.3.1-244.9 109.9-244.8 245.2v654c-.2 135.3 109.4 245.1 244.7 245.3 135.3-.1 244.9-109.9 244.8-245.3z"
				fill={mono ? undefined : '#2eb67d'}
			/>
			<path
				d="m1550.1 2452.5c135.3-.1 244.9-109.9 244.8-245.2.1-135.3-109.5-245.1-244.8-245.2h-244.8v245.2c-.1 135.2 109.5 245 244.8 245.2zm0-654.1h652.7c135.3-.1 244.9-109.9 244.8-245.2.2-135.3-109.4-245.1-244.7-245.3h-652.7c-135.3.1-244.9 109.9-244.8 245.2-.1 135.4 109.4 245.2 244.7 245.3z"
				fill={mono ? undefined : '#ecb22e'}
			/>
			<path
				d="m0 1553.2c-.1 135.3 109.5 245.1 244.8 245.2 135.3-.1 244.9-109.9 244.8-245.2v-245.2h-244.8c-135.3.1-244.9 109.9-244.8 245.2zm652.7 0v654c-.2 135.3 109.4 245.1 244.7 245.3 135.3-.1 244.9-109.9 244.8-245.2v-653.9c.2-135.3-109.4-245.1-244.7-245.3-135.4 0-244.9 109.8-244.8 245.1 0 0 0 .1 0 0"
				fill={mono ? undefined : '#e01e5a'}
			/>
		</g>
	</svg>
);
